import { DraftSatoSetResponse } from 'api/Responses/SatoResponses';
import { DraftTrayResponse, TrayVideo } from 'api/Responses/TrayResponses';

export const getSetData = (drafts: DraftSatoSetResponse[], setCode: string): DraftSatoSetResponse | undefined => {
  return drafts.find(draft => draft.code === setCode);
};

export const getTrayData = (
  drafts: DraftSatoSetResponse[],
  setCode: string,
  trayIndex: number,
): DraftTrayResponse | undefined => {
  return drafts.find(draft => draft.code === setCode)?.trays[trayIndex];
};

export const getVideoData = (
  drafts: DraftSatoSetResponse[],
  setCode: string,
  trayIndex: number,
  videoIndex: number,
): TrayVideo | undefined => {
  return drafts.find(draft => draft.code === setCode)?.trays[trayIndex]?.videos[videoIndex];
};

export const getTrayIndex = (drafts: DraftSatoSetResponse[], setCode: string, trayId: string): number => {
  const trayIndex = drafts
    .find(draft => draft.code === setCode)
    ?.trays.findIndex(tray => String(tray.tray_id) === String(trayId));

  return trayIndex !== undefined ? trayIndex : -1;
};

export const getIsResubmitted = (draft: DraftSatoSetResponse): boolean => {
  return !!(draft.submission_date && draft.submitted_by && draft.updated_date && draft.updated_by);
};

export const getSubmissionDate = (draft: DraftSatoSetResponse): string | undefined => {
  const updatedDate = draft.updated_date ? new Date(draft.updated_date) : undefined;
  const submissionDate = draft.submission_date ? new Date(draft.submission_date) : undefined;

  if (submissionDate && !updatedDate) {
    return submissionDate.toString();
  }

  if (submissionDate && updatedDate && updatedDate >= submissionDate) {
    return updatedDate.toString();
  }

  return undefined;
};

export const getDisplayedSubmissionDate = (draft: DraftSatoSetResponse): string | undefined => {
  const submissionDateAsString = getSubmissionDate(draft);

  if (submissionDateAsString) {
    const submissionDateAsDate = new Date(submissionDateAsString);

    return submissionDateAsDate.toLocaleString();
  }

  return undefined;
};
